import { useSelector } from "react-redux";

const usePagePermissions = (pagePath) => {
  const sidebarData = useSelector((state) => state.sidebar.data);

  if (!pagePath || !sidebarData?.length) return null;

  const [, menuCodeRaw, programCodeRaw] = pagePath.toLowerCase().split("/");
  const menuCode = menuCodeRaw?.toUpperCase();
  const programCode = programCodeRaw?.toUpperCase();

  const traverse = (items) => {
    for (const item of items) {
      if (
        item.type === "program" &&
        item.menuCode === menuCode &&
        item.programCode === programCode
      ) {
        return item.permissions;
      }

      if (item.children?.length) {
        const found = traverse(item.children);
        if (found) return found;
      }
    }
    return null;
  };

  return traverse(sidebarData);
};

export default usePagePermissions;
